
import React from "react";

import {Routes, Route} from "react-router";

import FormUsers from 'pages/User/Form/edit'
import User from "./pages/User";
import {ListUsers} from "./pages/User/List";
import DashboardGoals from "./pages/DashboardGoals";
import {Redirect} from "./pages/redirect";
import Upload from "./pages/Upload";
import Workflow from "./pages/Workflow";
import Logs from "./pages/Logs";
import Tags from "./pages/Tags";
import FormTag from "./pages/Tags/form";
import Messages from "./pages/Messages";
import Error404 from "./pages/Error/404";
import Error401 from "./pages/Error/401";
import {ModalAdvanceStatus} from "./components/ModalAdvanceStatus";
import Documents from "./pages/Documents";
import Content from "./pages/Content";
import FormContent from "./pages/Content/form";
import TabsFormCollect from "./pages/Collect/tabs";



import {Navigate} from "react-router";
import Collect from "./pages/Collect";
import FormTranslate from "./pages/Collect/Form/form-translate";
import ListIndicators from "./pages/ListIndicators";
import Configs from "./pages/Configs";
import {IndicatorProvider} from "./contexts/IndicatorsContext";
import DashboardIndicators from "./pages/DashboardIndicators";
import {GoalProvider} from "./contexts/GoalsContext";

const RoutesApp = () => {
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/dashboard/indicators"/>}/>

            <Route path="/dashboard/indicators" element={
                <IndicatorProvider>
                    <DashboardIndicators/>
                </IndicatorProvider>
            }>
                <Route path="auth/:param/:id" element={<ModalAdvanceStatus/>}/>
            </Route>

            <Route path="/dashboard/goals" element={
                <GoalProvider>
                    <DashboardGoals/>
                </GoalProvider>

            }>
                <Route path="auth/:param/:id" element={<ModalAdvanceStatus/>}/>
            </Route>

            <Route path="/upload/:param" element={<Upload/>}>
                <Route path="auth/:param/:id" element={<ModalAdvanceStatus/>}/>
            </Route>

            <Route path="/workflow/goals" element={<Workflow/>}>
                <Route path=":id" element=''/>
                <Route path="auth/goals/:id" element={<ModalAdvanceStatus/>}/>
            </Route>
            <Route path="/collect/indicators" element={<Collect />} />
            <Route path="/collect/indicator/add" element={<TabsFormCollect />} />
            <Route path="/collect/indicator/edit/:id" element={<TabsFormCollect />} />
            <Route path="/collect/translate/:code" element={<FormTranslate />} />
            <Route path="/documents" element={<Documents/>}/>
            <Route path="/logs" element={<Logs />}/>
            <Route path="/users" element={<User />}>
                <Route path="list" element={<ListUsers/>}/>
                {/*<Route path="add" element={<NewUsers/>}/>*/}
                <Route path="edit/:id" element={<FormUsers/>}/>
            </Route>
            <Route path="/tags" element={<Tags/>}/>
            <Route path="/tags/add" element={<FormTag/>}/>
            <Route path="/tags/edit/:id" element={<FormTag/>}/>
            <Route path="/list" element={<ListIndicators/>}/>
            <Route path="/user" element={<User/>}>
                <Route path="add" element={<FormUsers/>}/>
                <Route path="edit/:id" element={<FormUsers/>}/>
            </Route>
            <Route path="/notifications" element={<Messages/>}/>
            <Route path="/content" element={<Content/>}>
                <Route path="add" element={<FormContent/>}/>
                <Route path="edit/:id" element={<FormContent/>}/>
            </Route>
            <Route path="/admin" element={<Configs/>}/>
            <Route path="/unauthorized" element={<Error401/>}/>
            <Route path="*" element={<Error404/>}/>
            <Route path="/redirect/:where/:param/:id" element={<Redirect/>}/>
        </Routes>
    );
}

export default RoutesApp
